// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useLogsPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canReadLogs = authContext.isAuthorized(true, tenantId, IPermissions.LOGS_READ);
    var canExportLogs = authContext.isAuthorized(true, tenantId, IPermissions.LOGS_EXPORT);
    var canAuditLogs = authContext.isAuthorized(true, tenantId, IPermissions.ELECTORAL_LOG_AUDIT);
    var canReadTenantLogs = authContext.isAuthorized(true, tenantId, IPermissions.TENANT_LOGS_READ);
    // Harvest refuses a tenant log export to anyone who can't read the log.
    var canExportTenantLogs = canReadTenantLogs &&
        authContext.isAuthorized(true, tenantId, IPermissions.TENANT_LOGS_EXPORT);
    var showLogsColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_LOGS_COLUMNS);
    var showLogsFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_LOGS_FILTERS);
    /**
     * Permissions
     */
    return {
        canReadLogs: canReadLogs,
        canExportLogs: canExportLogs,
        canAuditLogs: canAuditLogs,
        canReadTenantLogs: canReadTenantLogs,
        canExportTenantLogs: canExportTenantLogs,
        showLogsColumns: showLogsColumns,
        showLogsFilters: showLogsFilters,
    };
}
